import React from 'react';
import { Link } from 'gatsby';
import { Container } from 'react-grid-system';
import { Disclosure } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { Navigation } from './nav/links';

import Logo from '../../../images/logo.svg';

// function check link

const isExternalLink = (link) => {
  return !!link.includes('http');
};

export default function Header() {
  // Mobile Dropdown Navigation
  function mobToggle(e) {
    let target = e.target;
    target.classList.toggle('active');
    // focus
  }

  const buttonClasses =
    'flex p-6 rounded-md duration-300 justify-center items-center bg-red-500 border-red-500 hover:border-gray-700 text-center nav-button';

  return (
    <div className="nav-container sticky top-0 md:absolute w-full">
      <Disclosure as="nav">
        {({ open }) => (
          <>
            <Container className="py-3 mx-auto relative flex items-center justify-between md:block nav-wrap">
              <div className="flex items-center justify-between">
                <div className="nav-logo">
                  <Link to="/">
                    <img className="w-3/5" src={Logo} alt="Logo" />
                  </Link>
                </div>
                <div className="navigation-wrapper hidden md:ml-6 md:flex">
                  <ul className="flex">
                    {Navigation.map((link, i) => {
                      return (
                        <li className="relative" key={i}>
                          <Link
                            to={link.link}
                            className={`inline-flex items-center pt-1 mr-10 text-white parent ${
                              link.isButton ? buttonClasses : ''
                            }`}
                            activeClassName="border-indigo-500 active"
                          >
                            {link.title}
                          </Link>
                          <ul className="flex">
                            {link.subnav.map((sublink, i) => {
                              const PdfLink = () => (
                                <a
                                  href={sublink.link}
                                  className="inline-flex items-center pt-1 mr-10"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {sublink.title}
                                </a>
                              );

                              const BackLink = () => (
                                <a
                                  href={sublink.link}
                                  className="inline-flex items-center pt-1 mr-10"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {sublink.title}
                                </a>
                              );

                              const InternalLink = () => {
                                const internalLink = `${link.link}/${sublink.link}`;

                                const directInternalLink = `/${sublink.link}`;

                                const linkTo = sublink.isDirectLink
                                  ? directInternalLink
                                  : internalLink;
                                return (
                                  <Link
                                    to={linkTo}
                                    className="inline-flex items-center pt-1 mr-10"
                                    activeClassName="border-indigo-500 active"
                                  >
                                    {sublink.title}
                                  </Link>
                                );
                              };

                              return (
                                <li key={i}>
                                  {!sublink.pdf === true ? (
                                    <>
                                      {isExternalLink(sublink.link) ? (
                                        // back link
                                        <BackLink />
                                      ) : (
                                        // internal link
                                        <InternalLink />
                                      )}
                                    </>
                                  ) : (
                                    <PdfLink />
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              {/* Mobile Navigation */}
              <div className="flex items-center md:hidden">
                <Disclosure.Button
                  aria-label="Mobile Menu"
                  className="inline-flex burger-container items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                >
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-12 w-12" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-12 w-12" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </Container>
            <Disclosure.Panel className="md:hidden">
              <div className="pt-2 pb-3 space-y-1 mobile-menu">
                <ul>
                  {Navigation.map((link, i) => {
                    return (
                      <li
                        onClick={mobToggle}
                        className={`${
                          link.subnav.length > 1 ? 'parent-link' : ''
                        }`}
                        key={i}
                        style={{ ariaHidden: 'true' }}
                      >
                        <Link
                          to={link.link}
                          className="border-t-2 block pl-3 pr-4 py-4 font-medium"
                          activeClassName="border-indigo-500  active"
                        >
                          {link.title}
                        </Link>
                        {link.subnav.map((sublink, index) => {
                          const PdfLink = () => (
                            <a
                              href={sublink.link}
                              className="items-center pt-1 mr-10 hidden pl-10"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {sublink.title}
                            </a>
                          );

                          const BackLink = () => {
                            // console.log(sublink.link);
                            return (
                              <a
                                href={sublink.link}
                                className=" pl-10 items-center pt-1 mr-1 hidden"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {sublink.title}
                              </a>
                            );
                          };

                          const InternalLink = () => {
                            const internalLink = `${link.link}/${sublink.link}`;

                            const directInternalLink = `/${sublink.link}`;

                            const linkTo = sublink.isDirectLink
                              ? directInternalLink
                              : internalLink;
                            return (
                              <Link
                                to={linkTo}
                                className="border-t-2 pl-10 pr-4 py-4 font-medium hidden"
                                activeClassName="border-indigo-500 active"
                              >
                                {sublink.title}
                              </Link>
                            );
                          };
                          return (
                            <React.Fragment key={index}>
                              {!sublink.pdf === true ? (
                                <>
                                  {isExternalLink(sublink.link) ? (
                                    // back link
                                    <BackLink />
                                  ) : (
                                    // internal link
                                    <InternalLink />
                                  )}
                                </>
                              ) : (
                                <PdfLink />
                              )}
                            </React.Fragment>
                          );
                        })}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
